"use client";

import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useFavorites } from "./local-tool-storage";

type FavoriteButtonProps = {
  toolId: string;
  className?: string;
};

export function FavoriteButton({ toolId, className }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(toolId);

  return (
    <Button
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
      title={active ? "Remove from favorites" : "Add to favorites"}
      type="button"
      size="icon"
      variant="ghost"
      className={cn("h-8 w-8", className)}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleFavorite(toolId);
      }}
    >
      <Star
        className={cn(
          "h-4 w-4",
          active ? "fill-amber-400 text-amber-500" : "text-zinc-400",
        )}
      />
    </Button>
  );
}
